import script from "./TagEditList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagEditList.vue?vue&type=script&lang=ts&setup=true"

import "./TagEditList.vue?vue&type=style&index=0&id=d9d6da02&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9d6da02"]])

export default __exports__